import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Table, } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';

import DatePicker from 'react-datepicker';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import fr from 'date-fns/locale/fr';
registerLocale('fr', fr);
setDefaultLocale('fr');

const DemandeDPSStep3OnePartie = ({
    errors,
    partieInitiale,
    updatePartieFromComponent,
    removePartieFromComponent,
    step2watch,
}) => {
    const [partie, setPartie] = useState();
    useEffect(()=>{
        setPartie({
            ...partieInitiale,
            publicPresent: partieInitiale.effectifPublicP1 == 0 ? false : true,
            acteurPresent: partieInitiale.effectifActeurs == 0 ? false : true,
        })
    },[partieInitiale.id])

    const updateProp = (propName, value) => {
        setPartie({
            ...partie,
            [propName]: value,
        })
    }

    useEffect(()=>{
        if(partie)
        {
            updatePartieFromComponent(partie);
        }
    },[partie])

    useEffect(()=>{
        if(partieInitiale)
        {
            setPartie(partieInitiale);
        }
    },[])

    if(partie)
    {
        return (<>
            <div className={"border border-1 rounded-4 p-2 position-relative mb-3 border-primary"}>
                <center><h5 className='text-primary mb-2'>
                    Plage #{partie.id}
                    <IconButton
                        icon='trash'
                        variant='outline-danger'
                        size='sm'
                        className='ms-3'
                        onClick={()=>{removePartieFromComponent(partieInitiale.id)}}
                    />
                </h5></center>
                <div className="d-none d-md-block">
                    <Table bordered size='sm'>
                        <thead>
                            <tr key={'ligne1'}>
                                <th colSpan={"2"}><center>Votre évènement</center></th>
                                <th colSpan={"2"}><center>Présence Secouristes</center></th>
                            </tr>
                            <tr key={'ligne2'}>
                                <th style={{ width: '25%',}}><center>Début</center></th>
                                <th style={{ width: '25%',}}><center>Fin</center></th>
                                <th style={{ width: '25%',}}><center>Début</center></th>
                                <th style={{ width: '25%',}}><center>Fin</center></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={'ligne3'}>
                                <td>
                                    <DatePicker
                                        id="dateDebutPartieEvenement"
                                        name="dateDebutPartieEvenement"
                                        selected={partie.dateDebutPartieEvenement}
                                        onChange={(date)=>{updateProp("dateDebutPartieEvenement", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Choisir une date et heure"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateDebutPartieEvenement ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieEvenement && partie.dateFinPartieEvenement && partie.dateFinPartieEvenement <= partie.dateDebutPartieEvenement ? "La fin doit être après le début" : null}</small>
                                </td>
                                <td>
                                    <DatePicker
                                        id="dateFinPartieEvenement"
                                        name="dateFinPartieEvenement"
                                        selected={partie.dateFinPartieEvenement}
                                        onChange={(date)=>{updateProp("dateFinPartieEvenement", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Choisir une date et heure"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateFinPartieEvenement ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieEvenement && partie.dateFinPartieEvenement && partie.dateFinPartieEvenement <= partie.dateDebutPartieEvenement ? "La fin doit être après le début" : null}</small>
                                </td>
                                <td>
                                    <DatePicker
                                        id="dateDebutPartieSecours"
                                        name="dateDebutPartieSecours"
                                        selected={partie.dateDebutPartieSecours}
                                        onChange={(date)=>{updateProp("dateDebutPartieSecours", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Choisir une date et heure"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateDebutPartieSecours ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieSecours && partie.dateFinPartieSecours && partie.dateFinPartieSecours <= partie.dateDebutPartieSecours ? "La fin doit être après le début" : null}</small>
                                </td>
                                <td>
                                    <DatePicker
                                        id="dateFinPartieSecours"
                                        name="dateFinPartieSecours"
                                        selected={partie.dateFinPartieSecours}
                                        onChange={(date)=>{updateProp("dateFinPartieSecours", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Choisir une date et heure"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateFinPartieSecours ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieSecours && partie.dateFinPartieSecours && partie.dateFinPartieSecours <= partie.dateDebutPartieSecours ? "La fin doit être après le début" : null}</small>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                
                <div className="d-md-none">
                    <Table bordered size='sm'>
                        <thead>
                            <tr key={'ligne4'}>
                                <th><center>Votre évènement</center></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={'ligne5'}>
                                <td>
                                    <DatePicker
                                        id="dateDebutPartieEvenement"
                                        name="dateDebutPartieEvenement"
                                        selected={partie.dateDebutPartieEvenement}
                                        onChange={(date)=>{updateProp("dateDebutPartieEvenement", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Début"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}    
                                    />
                                    <small className="text-danger">{!partie.dateDebutPartieEvenement ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieEvenement && partie.dateFinPartieEvenement && partie.dateFinPartieEvenement <= partie.dateDebutPartieEvenement ? "La fin doit être après le début" : null}</small>
                                </td>
                            </tr>
                            <tr key={'ligne6'}>
                                <td>
                                    <DatePicker
                                        id="dateFinPartieEvenement"
                                        name="dateFinPartieEvenement"
                                        selected={partie.dateFinPartieEvenement}
                                        onChange={(date)=>{updateProp("dateFinPartieEvenement", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Fin"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateFinPartieEvenement ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieEvenement && partie.dateFinPartieEvenement && partie.dateFinPartieEvenement <= partie.dateDebutPartieEvenement ? "La fin doit être après le début" : null}</small>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                    <Table bordered size='sm'>
                        <thead>
                            <tr key={'ligne7'}>
                                <th><center>Présence Secouristes</center></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={'ligne8'}>
                                <td>
                                    <DatePicker
                                        id="dateDebutPartieSecours"
                                        name="dateDebutPartieSecours"
                                        selected={partie.dateDebutPartieSecours}
                                        onChange={(date)=>{updateProp("dateDebutPartieSecours", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Début"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateDebutPartieSecours ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieSecours && partie.dateFinPartieSecours && partie.dateFinPartieSecours <= partie.dateDebutPartieSecours ? "La fin doit être après le début" : null}</small>
                                </td>
                            </tr>
                            <tr key={'ligne9'}>
                                <td>
                                    <DatePicker
                                        id="dateFinPartieSecours"
                                        name="dateFinPartieSecours"
                                        selected={partie.dateFinPartieSecours}
                                        onChange={(date)=>{updateProp("dateFinPartieSecours", date)}}
                                        formatWeekDay={day => day.slice(0, 3)}
                                        className='form-control'
                                        placeholderText="Fin"
                                        timeIntervals={15}
                                        dateFormat="dd/MM/yyyy HH:mm"
                                        showTimeSelect
                                        fixedHeight
                                        locale="fr"
                                        minDate={new Date(step2watch("dateDebutEvenement"))}
                                    />
                                    <small className="text-danger">{!partie.dateFinPartieSecours ? "Champ obligatoire" : null}</small>
                                    <small className="text-danger">{partie.dateDebutPartieSecours && partie.dateFinPartieSecours && partie.dateFinPartieSecours <= partie.dateDebutPartieSecours ? "La fin doit être après le début" : null}</small>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                </div>
                

                <hr/>

                <Row>
                    <Col md={6}className="border-end">
                        <Form.Group className="mb-2">
                            <Form.Label>Présence de public <small className="text-info"><br/>(Personnes assistant à la prestation, spectateurs, encouragent les acteurs/coureurs/compétiteurs, famille des coureurs, ...)</small></Form.Label>
                            <Form.Check 
                                key={"public-nenant" + partieInitiale.id}
                                type='radio'
                                id={"public-nenant" + partieInitiale.id}
                                label={<div className='text-warning'>Il n'y a aucun public</div>}
                                name={'publicPresent' + partieInitiale.id}
                                checked={!partie.publicPresent}
                                onChange={(e)=>{if(e.target.checked){updateProp("publicPresent",false)}}}
                                isInvalid={errors && errors.publicPresent}
                            />
                            <Form.Check 
                                key={"public-present" + partieInitiale.id}
                                type='radio'
                                id={"public-present" + partieInitiale.id}
                                label={<div className='text-success'>Public présent</div>}
                                name={'publicPresent' + partieInitiale.id}
                                checked={partie.publicPresent}
                                onChange={(e)=>{if(e.target.checked){updateProp("publicPresent",true)}}}
                                isInvalid={errors && errors.publicPresent}
                            />
                        </Form.Group>
                        
                        {partie.publicPresent ?
                            <>
                                <Form.Group className="mb-2">
                                    <Form.Label>Effectif public attendu</Form.Label>
                                    <Form.Control type="number" min={0} step={1} name="effectifPublicP1" id="effectifPublicP1" value={partie.effectifPublicP1} onChange={(e)=>{updateProp("effectifPublicP1",e.target.value ? parseInt(e.target.value) : null)}} isInvalid={errors && errors.effectifPublicP1}/>
                                    <small className="text-danger">{errors ? errors.effectifPublicP1?.message : null}</small>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Comportement du public</Form.Label>
                                    <Form.Check 
                                        key={"p2-0.25-" + partieInitiale.id}
                                        type='radio'
                                        id={"p2-0.25-" + partieInitiale.id}
                                        label={<>Public assis <small>spectacle, cérémonie cultuelle, réunion publique, restauration, rendez-vous sportif...</small></>}
                                        name={'p2-' + partieInitiale.id}
                                        checked={partie.typePublicP2 == 0.25}
                                        onChange={(e)=>{if(e.target.checked){updateProp("typePublicP2", 0.25)}}}
                                        isInvalid={errors && errors.typePublicP2}
                                    />
                                    <Form.Check 
                                        key={"p2-0.30-" + partieInitiale.id}
                                        type='radio'
                                        id={"p2-0.30-" + partieInitiale.id}
                                        label={<>Public debout <small>cérémonie cultuelle, réunion publique, restauration, exposition, foire, salon, comice agricole...</small></>}
                                        name={'p2-' + partieInitiale.id}
                                        checked={partie.typePublicP2 == 0.30}
                                        onChange={(e)=>{if(e.target.checked){updateProp("typePublicP2", 0.30)}}}
                                        isInvalid={errors && errors.typePublicP2}
                                    />
                                    <Form.Check 
                                        key={"p2-0.35-" + partieInitiale.id}
                                        type='radio'
                                        id={"p2-0.35-" + partieInitiale.id}
                                        label={<>Public debout <small>spectacle avec public statique, fête foraine, rendez-vous sportif avec protection du public par rapport à  l'événement...</small></>}
                                        name={'p2-' + partieInitiale.id}
                                        checked={partie.typePublicP2 == 0.35}
                                        onChange={(e)=>{if(e.target.checked){updateProp("typePublicP2", 0.35)}}}
                                        isInvalid={errors && errors.typePublicP2}
                                    />
                                    <Form.Check 
                                        key={"p2-0.40-" + partieInitiale.id}
                                        type='radio'
                                        id={"p2-0.40-" + partieInitiale.id}
                                        label={<>Public debout <small>spectacle avec public dynamique, danse, feria, fête votive, carnaval, spectacle de rue, grande parade, rendez-vous sportif sans protection du public par rapport à  l'événement ... Evénement se déroulant sur plusieurs jours avec présence permanente du public : hébergement sur site ou à proximité.</small></>}
                                        name={'p2-' + partieInitiale.id}
                                        checked={partie.typePublicP2 == 0.40}
                                        onChange={(e)=>{if(e.target.checked){updateProp("typePublicP2", 0.40)}}}
                                        isInvalid={errors && errors.typePublicP2}
                                    />
                                    <small className="text-danger">{errors ? errors.typePublicP2?.message : null}</small>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <Form.Label>Alcool</Form.Label>
                                    <Form.Check 
                                        key="venteAlcool"
                                        type='switch'
                                        id="venteAlcool"
                                        label="Vente d'alcool sur le site"
                                        name='venteAlcool'
                                        checked={partie.venteAlcool}
                                        onChange={(e)=>{updateProp("venteAlcool", e.target.checked);}}
                                        isInvalid={errors && errors.venteAlcool}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <Form.Label>Risques particuliers pour le public</Form.Label>
                                    <Form.Control as="textarea" rows={4} name="risquesPublic" id="risquesPublic" value={partie.risquesPublic} onChange={(e)=>{updateProp("risquesPublic",parseInt(e.target.value))}} isInvalid={errors && errors.risquesPublic}/>
                                </Form.Group>
                            </>
                        : null}

                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-2">
                            <Form.Label>Présence d'acteurs <small className="text-info"><br/>(Compétiteurs, coureurs, acteurs sur scene, ...)</small></Form.Label>
                            <Form.Check 
                                key={"acteur-nenant" + partieInitiale.id}
                                type='radio'
                                id={"acteur-nenant" + partieInitiale.id}
                                label={<div className='text-warning'>Pas de dispositif acteur nécessaire</div>}
                                name={'acteurPresent' + partieInitiale.id}
                                checked={!partie.acteurPresent}
                                onChange={(e)=>{if(e.target.checked){updateProp("acteurPresent",false)}}}
                                isInvalid={errors && errors.acteurPresent}
                            />
                            <Form.Check 
                                key={"acteur-present" + partieInitiale.id}
                                type='radio'
                                id={"acteur-present" + partieInitiale.id}
                                label={<div className='text-success'>Dispositif acteur nécessaire</div>}
                                name={'acteurPresent' + partieInitiale.id}
                                checked={partie.acteurPresent}
                                onChange={(e)=>{if(e.target.checked){updateProp("acteurPresent",true)}}}
                                isInvalid={errors && errors.acteurPresent}
                            />
                        </Form.Group>
                        
                        {partie.acteurPresent ?
                            <>
                                <Form.Group className="mb-2">
                                    <Form.Label>Effectif acteurs</Form.Label>
                                    <Form.Control type="number" min={0} step={1} name="effectifActeurs" id="effectifActeurs" value={partie.effectifActeurs} onChange={(e)=>{updateProp("effectifActeurs",e.target.value ? parseInt(e.target.value) : null)}} isInvalid={errors && errors.effectifActeurs}/>
                                    <small className="text-danger">{errors ? errors.effectifActeurs?.message : null}</small>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <Form.Label>Activité des acteurs</Form.Label>
                                    <Form.Control type="text" name="activiteActeurs" id="activiteActeurs" value={partie.activiteActeurs} onChange={(e)=>{updateProp("activiteActeurs",e.target.value ? e.target.value : null)}} isInvalid={errors && errors.activiteActeurs}/>
                                    <small className="text-danger">{errors ? errors.activiteActeurs?.message : null}</small>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                    <Form.Label>Risques particuliers pour les acteurs</Form.Label>
                                    <Form.Control as="textarea" rows={4} name="risquesActeurs" id="risquesActeurs" value={partie.risquesActeurs} onChange={(e)=>{updateProp("risquesActeurs",e.target.value ? e.target.value : null)}} isInvalid={errors && errors.risquesActeurs}/>
                                        <small className="text-danger">{errors ? errors.risquesActeurs?.message : null}</small>
                                </Form.Group>
                            </>
                        : null}
                    </Col>
                </Row>

                <hr/>

                <Form.Group className="mb-2">
                    <Form.Label>Elements particuliers</Form.Label>
                    <Form.Check 
                        key="pyrotechnie"
                        type='switch'
                        id="pyrotechnie"
                        label="Présence de pyrotechnie"
                        name='pyrotechnie'
                        checked={partie.pyrotechnie}
                        onChange={(e)=>{updateProp("pyrotechnie", e.target.checked);}}
                        isInvalid={errors && errors.pyrotechnie}
                    />
                    <Form.Check 
                        key="enginsMotrises"
                        type='switch'
                        id="enginsMotrises"
                        label="Présence d'engins motorisés"
                        name='enginsMotrises'
                        checked={partie.enginsMotrises}
                        onChange={(e)=>{updateProp("enginsMotrises", e.target.checked);}}
                        isInvalid={errors && errors.enginsMotrises}
                    />
                </Form.Group>
            </div>
        </>);
    }
};


DemandeDPSStep3OnePartie.propTypes = {};

export default DemandeDPSStep3OnePartie;